import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchSiteConfig } from '../api';
import { siteConfig as fallback } from '../mock';

const SiteConfigContext = createContext(fallback);

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(fallback);

  useEffect(() => {
    fetchSiteConfig()
      .then((data) => {
        if (data) setConfig(data);
      })
      .catch(() => {});
  }, []);

  return (
    <SiteConfigContext.Provider value={config}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext);
